export const TOGGLE_AUTH_MODAL = 'TOGGLE_AUTH_MODAL'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const LOG_OUT = 'LOG_OUT'
export const AUTH_ERROR = 'AUTH_ERROR'
export const UPDATE_AUTH_TOKEN = 'UPDATE_AUTH_TOKEN'
export const SET_USER = 'SET_USER'



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations-types.js